import type { BimPriceLevelEnum } from 'gql/graphql';
import { WorkOrderStatusEnum } from 'gql/graphql';
import { BimWorkOrderTotalsTable } from 'pages/Project/BimProject/BimCommonComponents/BimWorkOrderTotalsTable';

import type { AgGridReact } from 'ag-grid-react';
import { type ForwardedRef, forwardRef, useMemo } from 'react';

import { useBimWorkOrderChangeTotals } from '../hooks';

type TBimWorkOrderChangeTotalsTable = {
    workOrderChangeId: number;
    chapter: string;
    constructionTypeId: number | undefined;
    priceLevel: BimPriceLevelEnum | undefined;
};
export const BimWorkOrderChangeTotalsTable = forwardRef(
    (props: TBimWorkOrderChangeTotalsTable, ref: ForwardedRef<AgGridReact<any>>) => {
        const { workOrderChangeId, constructionTypeId, chapter, priceLevel } = props;

        const { rowTotalsData } = useBimWorkOrderChangeTotals({
            workOrderChangeId,
            constructionTypeId,
            chapter,
            workOrderChangeObjectId: undefined,
            workOrderObjectId: undefined,
            withEffect: true,
            priceLevel,
        });

        const mappedRowTotalsData = useMemo(
            () =>
                rowTotalsData.map((item) => ({
                    ...item.planValue,
                    ...item,
                })),
            [rowTotalsData],
        );

        return (
            <BimWorkOrderTotalsTable
                tableRef={ref}
                tableData={mappedRowTotalsData}
                workOrderStatus={WorkOrderStatusEnum.InProgress}
                hasInProgress={false}
                isFrameContract
            />
        );
    },
);

BimWorkOrderChangeTotalsTable.displayName = 'BimWorkOrderChangeTotalsTable';
